import { render, staticRenderFns } from "./PlayerBottom.vue?vue&type=template&id=2279e1d9&scoped=true&"
import script from "./PlayerBottom.vue?vue&type=script&lang=js&"
export * from "./PlayerBottom.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBottom.vue?vue&type=style&index=0&id=2279e1d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2279e1d9",
  null
  
)

export default component.exports